export default "precision mediump float;\r\nattribute vec2 position;\r\n\r\nvoid main()\r\n{\r\n    gl_Position = vec4( position, 0.0, 1.0 );\r\n}";